import { Plural, Trans } from '@lingui/react/macro';
import { InformationCircle } from '@remarkable/ark-icons';
import { Typography } from '@remarkable/ark-web';

interface RejectProps {
  numberOfFiles: number;
}

export const DropReject = ({ numberOfFiles }: RejectProps) => {
  return (
    <div
      data-cy="drop-rejected"
      className="flex size-full flex-row items-center justify-center p-32 text-left"
      style={{
        backgroundImage: `url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' stroke='%23F99690' stroke-width='1' stroke-dasharray='8%2c 8' stroke-dashoffset='3' stroke-linecap='butt'/%3e%3c/svg%3e")`,
      }}
    >
      <div className="flex flex-col items-center gap-8 lm:flex-row lm:items-start">
        <InformationCircle size={32} className="mt-4 text-text-muted" />
        <div className="w-4/5 lm:w-auto">
          <Typography variant="body-2xl" className="hidden md:block">
            <Plural
              value={numberOfFiles}
              one={
                <Trans>
                  This file format is <strong>not supported</strong>.
                </Trans>
              }
              other={
                <Trans>
                  Some of the files are <strong>not supported</strong>.
                </Trans>
              }
            />
          </Typography>

          <Typography variant="body-sm" className="text-center md:text-left">
            <Trans>
              Supports PDF, JPG, PNG, and EPUB files up to {100} MB.
            </Trans>
          </Typography>
        </div>
      </div>
    </div>
  );
};
